import { css } from '@emotion/react';
import { TextBody2RRMixin, TextSubtitle2RBMixin, WidgetLayout } from '@mobalytics/shared';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { paymentFormHeaderCss } from '../../../../payment-details.styles';

interface Props {
  className?: string;
  title: string;
  description: string;
}

export const SavedPaymentInfo: React.FC<Props> = (props) => {
  const { className, title, description } = props;
  const { t } = useTranslation();
  return (
    <div className={className}>
      <p css={paymentFormHeaderCss}>{t('Your payment details')}</p>
      <WidgetLayout>
        <p css={headerCss}>{title}</p>
        <p css={labelCss}>{description}</p>
      </WidgetLayout>
    </div>
  );
};

const headerCss = css`
  ${TextSubtitle2RBMixin};
  margin-bottom: 12px;
`;

const labelCss = css`
  ${TextBody2RRMixin};
`;
